<script>
  import videoUploadStore from "../stores/Video/videoUpload";
  import DynamicDialog from "../views/overlays/dynamicDialog.svelte";
  import ProgressCircle from "svelte-progresscircle";
  import Icon, { InformationCircle } from "svelte-hero-icons";

  let files = [];
  videoUploadStore.subscribe((s) => {
    if (s.showModal) {
      files = Object.values(s.files);
    }
  });
  const titles = ["Asset Name", "Video File", "Status"];
</script>

<!-- This example requires Tailwind CSS v2.0+ -->
<DynamicDialog
  showModal={$videoUploadStore.showModal}
  onClose={videoUploadStore.reset}
>
  <div class="flex flex-col">
    <div class="font-bold text-2xl text-center">Assets Bulk Upload Summary</div>
    <div class="my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                {#each titles as title}
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {title}
                  </th>
                {/each}
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              {#each files as vid}
                <tr key={vid.title}>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {vid.title}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                  >
                    {vid.original_filename}
                  </td>
                  <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <img
                      src={vid.thumbnail_url}
                      alt=""
                      height="auto"
                      width="100"
                    />
                  </td> -->
                  <td class="px-6 py-4 whitespace-nowrap text-sm ">
                    <span
                      class={vid.state.error
                        ? "text-red-400"
                        : vid.state.warning
                        ? "text-yellow-500"
                        : "text-green-500"}
                    >
                      {#if Array.isArray(vid.state.message)}
                        <ul
                          class={vid.state.message.length > 1
                            ? "bullets"
                            : null}
                        >
                          {#each vid.state.message as msg}
                            <li>{msg}</li>
                          {/each}
                        </ul>
                      {:else}
                        {vid.state.message}
                        {#if vid.state.warningMsgs}
                          <ul>
                            {#each vid.state.warningMsgs as msg}
                              <li class="text-yellow-500">
                                <Icon
                                  src={InformationCircle}
                                  class="h-6 w-6 outline-none text-yellow-500 inline-block mr-2"
                                />{msg}
                              </li>
                            {/each}
                          </ul>
                        {/if}
                      {/if}
                    </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                  />
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</DynamicDialog>
{#if $videoUploadStore.showBar}
  <div
    aria-live="assertive"
    class="bg-white bottom-2 fixed pointer-events-none px-4 py-6 right-2 right-7 rounded rounded-2xl shadow-nv z-100"
  >
    <div class="flex justify-between">
      <div id="progresscircle" class="w-16 h-8">
        <ProgressCircle
          max={$videoUploadStore.size}
          value={$videoUploadStore.progress + 1}
        />
      </div>
      <h4 class="font-bold m-auto">Uploading Bulk Assets</h4>
      <div class="text-grey-400 m-auto ml-10">
        <span class="text-custom-orange">{$videoUploadStore.progress + 1}</span>
        out of {$videoUploadStore.size}
      </div>
    </div>
    <div class="text-center text-custom-red mt-3">
      A refresh or exit page will stop the uploading
    </div>
  </div>
{/if}

<style>
  #progresscircle {
    --progress-color: #f78907;
    --progress-trackcolor: transparent;
  }
  .bullets {
    list-style: initial !important;
  }
</style>
